import Vue from 'vue'
import router from './router'
import store from './store'
import '@/plugins'
import '@/assets/styles/style.scss'

import App from './App.vue'

import AnonymousLayout from './layouts/Anonymous.vue'
import DashboardLayout from './layouts/Dashboard.vue'
import DefaultLayout from './layouts/Default.vue'

import Parallax from './components/Parallax.vue'

Vue.component('default-layout', DefaultLayout)
Vue.component('dashboard-layout', DashboardLayout)
Vue.component('anonymous-layout', AnonymousLayout)

Vue.component('parallax', Parallax)

const app = new Vue({
  router,
  store,
  render: h => h(App),
})

store.dispatch('addAnnouncement', { cta: '/tutoriel', message:
  `Salut, je suis <strong>Globulo</strong>. Je suis là pour vous accompagner dans l’utilisation de cette plateforme.`
})

if (document.cookie.replace(/(?:(?:^|.*;\s*)completeAnonymousSurvey\s*\=\s*([^;]*).*$)|^.*$/, "$1") !== "true") {
  store.dispatch('addAnnouncement', { layout: 'survey', cta: '/sondage/IhHBXt', message:
    `Répondez à quelques questions et donnez votre avis sur Globulo Quest.`
  })
}

store.dispatch('refreshInformations')
  .then((resolve) => {
    return null
  }, (reject) => {
    store.dispatch('signout')
    router.push( {name: 'home'} )
  })
  .finally(e => {
    setInterval(() => {
      store.dispatch('checkForUnseenNotifications')
    }, 10000)
    app.$mount('#app');
  })
